// Api v2 compatibility, these flags define what can and cannot be mutated through api v1 to retain consistency across the versions
export const Mutability = {
  fieldCondition: 1 << 0,
  numberFieldFallback: 1 << 1,
  currencyFieldFallback: 1 << 2,
  dateFieldFallback: 1 << 3,
  siblings: 1 << 4,
  relevantTranslations: 1 << 5,
};
